// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3im3y","title":"ClientReferral_title__tBpVi","itemText":"ClientReferral_itemText__3Y1Ff"};